// Axis is the top-level category in the taxonomy.
// op = Naša operativa (OurOps)
// sn = Taktike protivnika (SNS Playbook)
// st = Strategija (Strategic)
// mo = Atmosfera (Morale)
// in = Incidenti (Incident triage)

export type Axis = 'op' | 'sn' | 'st' | 'mo' | 'in';

export const AXIS_META: Record<Axis, {
  code: Axis;
  label: string;             // short UI label in Serbian
  longLabel: string;         // full label
  pathSegment: string;       // URL segment
  colorVar: string;          // tailwind class fragment
  codePrefix: string;        // dimension code prefix, e.g. "OP-"
}> = {
  op: {
    code: 'op',
    label: 'Naša operativa',
    longLabel: 'Naša operativa — 14 stvari koje možemo da promenimo',
    pathSegment: 'operativa',
    colorVar: 'op',
    codePrefix: 'OP-',
  },
  sn: {
    code: 'sn',
    label: 'Taktike protivnika',
    longLabel: 'Taktike protivnika — 12 obrazaca SNS-a i fantom-misija',
    pathSegment: 'taktike-protivnika',
    colorVar: 'sn',
    codePrefix: 'SN-P',
  },
  st: {
    code: 'st',
    label: 'Strategija',
    longLabel: 'Veća pitanja',
    pathSegment: 'veca-pitanja',
    colorVar: 'st',
    codePrefix: 'ST-',
  },
  mo: {
    code: 'mo',
    label: 'Atmosfera',
    longLabel: 'Svedočanstva i utisci',
    pathSegment: 'glasovi',
    colorVar: 'mo',
    codePrefix: 'MO-',
  },
  in: {
    code: 'in',
    label: 'Incidenti',
    longLabel: 'Incidenti — interna analiza',
    pathSegment: 'incidenti',
    colorVar: 'in',
    codePrefix: 'I',
  },
};

// Map a dimension code (like "OP-09", "SN-P5", "ST-02") to its axis.
export function axisFromCode(code: string): Axis {
  if (code.startsWith('OP-')) return 'op';
  if (code.startsWith('SN-')) return 'sn';
  if (code.startsWith('ST-')) return 'st';
  if (code.startsWith('MO-')) return 'mo';
  if (code.startsWith('I')) return 'in';
  throw new Error(`Cannot determine axis for code: ${code}`);
}

// Get Tailwind class fragments for a given axis.
export function axisClasses(axis: Axis) {
  return {
    badge: `axis-badge axis-badge-${axis}`,
    quote: `quote-block quote-block-${axis}`,
    bg: `bg-axis-${axis}`,
    bgTint: `bg-axis-${axis}-tint`,
    text: `text-axis-${axis}-ink`,
    border: `border-axis-${axis}`,
  };
}
